import { Injectable, Pipe, PipeTransform } from '@angular/core';

const HIDE_COL = [
  // ID
  'id',
  'ostammid',
  'bparentid',
  'b_parentid',
  'omazsid',
  'omartid',
  'ospezid',
  'spezid',
  'typ_id',
  'lpid',
  'opruefid',
  'sperrid',
  'spid',
  'otypid',
  'tid',
  'sysiconid',
  'osispkid',
  // Bilder + icons
  'bild64',
  'bild',
  'helpbildbase64',
  'messpunktskizze',
  'typ_icon',
  'kavcolor',
  'richtung',
  // other
  'rights',
  'rechte',
  'h1',
  'h5',
  'h6',
  'h9',
  'h10',
  'ident',
  'delstatus',
  'typ_Line_Point',
  'hkav',
  'anzrep',
  'nomination_cts',
  // * wird mit Columns with Units ersetzt
  'nutzlaenge',
  'laenge',
  'minfk',
  'qicolor',
];

@Pipe({
  name: 'hideIDColumns',
})
@Injectable({ providedIn: 'root' })
export class HideIDColumnsPipe implements PipeTransform {
  /**
   * @param options additional columns to hide or object with hide and show
   * @returns true if hide
   */
  transform(value: unknown, options?: string[] | { hide?: string[]; show?: string[] }): boolean {
    // Wenn zusätzliche Logik vor hideIDColumnsPipe verwendet wurde
    if (!value) return false;
    if (typeof value == 'boolean') return value;
    if (typeof value != 'string') return false;

    value = value.toLowerCase();

    if (options && 'show' in options) {
      if (options.show.includes(value as string)) return false;
    }

    let hide = HIDE_COL;

    if (options) {
      hide = [...hide, ...(Array.isArray(options) ? options : (options.hide ?? []))];
    }

    return hide.includes(value as string);
  }
}
